import { Module } from "wrapper6";
import { addTooltips } from '../utils/_add-tooltips';

var $ = jQuery;

export default class Tooltip extends Module {

	ready() {

        addTooltips();
    }
}